import React from "react";
import styled, { keyframes } from "styled-components";
import { Loader2 } from "lucide-react";

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  width: 100%;

  svg {
    animation: ${spin} 1s linear infinite;
    color: var(--color-primary);
    width: 32px;
    height: 32px;
    stroke-width: 3;
  }
`;

export const LoadingSpinner = () => (
  <SpinnerWrapper>
    <Loader2 />
  </SpinnerWrapper>
);
